import React, { useState, useEffect, useRef } from 'react';
import 'react-dropzone-uploader/dist/styles.css'
import Select from 'react-select';
import moment from 'moment';
import { Drawer, Pagination, Space, Tooltip } from 'antd';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'

import { useTheme } from "./theme-provider.js"
import formatNumber from '../common_component/formatNumber.js';
import { ReportWidgetWrapper, ReportWidgetItem } from '../common_component/ReportWidgets.js';
import { getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js"
import PageError from '../common_component/PageError.js';

function AccountReport(props) {
    const [state, setState] = useState(2);
    const { theme, dropdownStyleDark } = useTheme()

    const daterange_picker_ref = useRef();
    const apiController = useRef(new AbortController())

    const [accountReportList, setAccountReportList] = useState([])
    const [accountReportApiState, setAccountReportApiState] = useState(false);

    const [listCount, setListCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [searchValue, setSearchValue] = useState(null)
    const [startDate, setStartDate] = useState(moment.utc().subtract(30, "days").format("YYYY-MM-DD"))
    const [endDate, setEndDate] = useState(moment.utc().format("YYYY-MM-DD"))
    const [baseCurrency, setBaseCurrency] = useState(null)

    const [branchList, setBranchlist] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [reportTypeList, setReportTypeList] = useState(["Credit", "Debit"]);
    const [AccountHeadList, setAccountHeadList] = useState([]);
    const [AllAccountHeadList, setAllAccountHeadList] = useState([]);

    const [selectedBranch, setSelectedBranch] = useState(null);
    const [selectedAccountCategory, setSelectedAccountCategory] = useState(null);
    const [selectedAccountHead, setSelectedAccountHead] = useState(null);
    const [reportType, setReportType] = useState("All");

    const [navtype, setnavtype] = useState("Overview");
    const [Dealer_name, setDealer_name] = useState("");
    const [Transaction_log_details, setTransaction_log_details] = useState(null);
    const [open, setOpen] = useState(false);



    var page_name = "account-report";

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)


    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    let formatNumberOptions = {
        removeTrailingZeros: true
    }

    async function selectiveaccounthead() {
        let arr = []
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/selective-account-head`, { method: 'POST', body: JSON.stringify({ "organization_id": organization_id, "headRequest": arr, "email": user.email, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        //console.log(body.data)

        if (body.operation === "success") {
            let temp_dropdown = [];
            let all_head = [];
            body.data.map((obj) => {
                var temp_obj = {};
                temp_obj.label = obj.category_name;
                temp_obj.value = obj.cid;
                let temp_dropdown1 = [];
                obj.headArray.map((obj1) => {
                    var temp_obj1 = {};
                    temp_obj1.label = obj1.name;
                    temp_obj1.value = obj1.hid;
                    temp_dropdown1.push(temp_obj1);
                    all_head.push(temp_obj1);
                })
                temp_obj.category_head = temp_dropdown1;
                temp_dropdown.push(temp_obj);
            })
            //console.log(temp_dropdown);
            setCategoryList(temp_dropdown);
            setAllAccountHeadList(all_head);
            setAccountHeadList([]);
            setSelectedAccountCategory({ label: "All", value: "All" });
            setSelectedAccountHead({ label: "All", value: "All" });
            setSelectedBranch({ label: "All", value: "All" });
        }
    }

    async function getBranchDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-branches`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)

        if (body.operation == "success") {
            setBranchlist(body.data);
            let temp = body.data.filter(option => option.default_branch == "yes")
            if (temp.length > 0) {
                //setSelectedBranch({ label: temp[0].branch_name, value: temp[0].branch_id });
            }
        }
        else {
            throw "branch list api error"
        }
    }
    async function getbasecurrency() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-base-currency`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.length > 0) {
            setBaseCurrency(body[0])
        }
    }

    async function getAccountReport(cp, rpp, search_v, sd, ed, account_category, account_head, branch, report_type) {
        if (accountReportApiState) {
            apiController.current.abort()
            apiController.current = new AbortController()
        }
        setAccountReportApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-account-report`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "selected_category": account_category, "selected_head": account_head, "selected_branch": branch, "report_type": report_type, "current_page": cp - 1, "rows_per_page": rpp, "search_value": search_v, "start_date": sd, "end_date": ed, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.data.length != 0) {
            setAccountReportList(body.data.list)
            setListCount(body.data.count)
            setAccountReportApiState(false)
        }
    }

    useEffect(() => {
        if (state === 1) {
            getAccountReport(currentPage, rowsPerPage, searchValue, startDate, endDate, selectedAccountCategory.value, selectedAccountHead.value, selectedBranch.value, reportType)
        }
    }, [currentPage, rowsPerPage, searchValue, startDate, endDate, selectedAccountCategory, selectedAccountHead, selectedBranch, reportType])

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getAccountReport(currentPage, rowsPerPage, searchValue, startDate, endDate, "All", "All", "All", "All");
            let p2 = selectiveaccounthead();
            let p3 = getBranchDetails();
            let p4 = getbasecurrency();
            Promise.all([p1, p2, p3, p4])
                .then(() => {
                    // getaccountheads();
                    setState(1);
                    console.log("all apis done")
                })
                .catch((err) => {
                    setState(0)
                    // console.log(err)
                })
        }

    }, [user, visibility, read, write])

    const onClose = () => {
        setOpen(false);
    }

    const AccountHeadLoad = (val) => {
        if (val.value == "All") {
            setAccountHeadList([]);
        }
        else {
            setAccountHeadList(val.category_head);
        }
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Account Report</h1>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Tooltip title="SpotERP Docs" >
                            <a
                                href={`${process.env.REACT_APP_SPOTERP_DOCS}/reports/bank/account_report`}
                                className='btn btn-light-primary py-2 px-3'
                                target="_blank"
                            >
                                <i className="bi bi-journal-text fs-1 px-0"></i>
                            </a>
                        </Tooltip>
                        <DateRangePickerComponent
                            ref={daterange_picker_ref}
                            allowEdit={false}
                            showClearButton={false}
                            focus={() => { daterange_picker_ref.current.show() }}
                            delayUpdate={true}
                            presets={[
                                { label: 'Today', start: new Date(), end: new Date() },
                                { label: 'Last 7 days', start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() },
                                { label: 'Last 30 days', start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
                                { label: 'Last 90 days', start: new Date(new Date().setDate(new Date().getDate() - 90)), end: new Date() }
                            ]}
                            change={(e) => {
                                setStartDate(moment(e.startDate).format("YYYY-MM-DD"));
                                setEndDate(moment(e.endDate).format("YYYY-MM-DD"));
                            }}
                            startDate={new Date(startDate)}
                            endDate={new Date(endDate)}
                            max={new Date().toISOString().split('T')[0]}
                        />
                    </div>
                </div>
                <div>
                    {
                        state == 1 ?
                            <>
                                <div className="row mb-sm-5 gx-0 ">
                                    <div className="col-md-3 px-1 mb-2">
                                        <label className="required fs-5 fw-bold mb-2">Account Category:</label>
                                        <Select
                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                            options={[{ label: "All", value: "All" }, ...categoryList]}
                                            onChange={(val) => {
                                                setSelectedAccountCategory(val);
                                                setSelectedAccountHead({ label: "All", value: "All" });
                                                AccountHeadLoad(val);
                                            }}
                                            value={selectedAccountCategory}
                                        />
                                    </div>
                                    <div className="col-md-3 px-1 mb-2">
                                        <label className="required fs-5 fw-bold mb-2">Account Head:</label>
                                        <Select
                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                            options={[{ label: "All", value: "All" }, ...AccountHeadList]}
                                            onChange={(val) => {
                                                setSelectedAccountHead(val);
                                            }}
                                            value={selectedAccountHead}
                                        />
                                    </div>
                                    <div className="col-md-3 px-1 mb-2">
                                        <label className="required fs-5 fw-bold mb-2">Branch:</label>
                                        <Select
                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                            options={[{ label: "All", value: "All" }, ...(branchList.map((x) => { return { label: x.branch_name, value: x.branch_id } }))]}
                                            onChange={(val) => {
                                                setSelectedBranch(val);
                                            }}
                                            value={selectedBranch}
                                            placeholder="Select Branch"
                                        />
                                    </div>
                                    <div className="col-md-3 px-1 mb-2">
                                        <label className="required fs-5 fw-bold mb-2">Type:</label>
                                        <Select
                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                            options={[{ label: "All", value: "All" }, ...reportTypeList.map((x) => { return { label: x, value: x } })]}
                                            onChange={(val) => {
                                                setReportType(val.value);
                                            }}
                                            value={{ label: reportType, value: reportType }}
                                        />
                                    </div>
                                </div>

                                <div className="card mb-5 mb-xl-8">
                                    <div className="card-header border-0 pt-5">
                                        <ReportWidgetWrapper>
                                            <ReportWidgetItem
                                                icon={<i className="bi bi-clipboard-data-fill display-6 me-2" style={{ color: "rgb(97 97 230 / 75%)" }}></i>}
                                                label={"Total Credit"}
                                                value={baseCurrency.currency_symbol + formatNumber(accountReportList.reduce((p, o) => p + o.deposit_amnt, 0), { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place, shorten: true, shortenFormat: '1K, 1L, 1Cr' })}
                                                hoverValue={baseCurrency.currency_symbol + formatNumber(accountReportList.reduce((p, o) => p + o.deposit_amnt, 0), { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}
                                            />
                                            <ReportWidgetItem
                                                icon={<i className="bi bi-cash-stack display-6 me-2" style={{ color: "rgb(97 97 230 / 75%)" }}></i>}
                                                label={"Total Debit"}
                                                value={baseCurrency.currency_symbol + formatNumber(accountReportList.reduce((p, o) => p + o.withdrawl_amnt, 0), { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place, shorten: true, shortenFormat: '1K, 1L, 1Cr' })}
                                                hoverValue={baseCurrency.currency_symbol + formatNumber(accountReportList.reduce((p, o) => p + o.withdrawl_amnt, 0), { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}
                                            />
                                        </ReportWidgetWrapper>
                                    </div>

                                    <div className="card-body py-3">
                                        <div className="mb-5">
                                            <input type="text" className='form-control fw-bold border border-primary' value={searchValue || ""} onChange={(e) => { setSearchValue(e.target.value) }} placeholder='Search...' />
                                        </div>

                                        <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                            {
                                                accountReportApiState ?
                                                    <div className="spinner-border text-primary w-75px h-75px my-auto"></div>
                                                    :
                                                    accountReportList.length > 0 ?
                                                        <>
                                                            <div className="mb-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                    showQuickJumper={true}
                                                                />
                                                            </div>

                                                            <div className='overflow-auto w-100 flex-grow-1'>
                                                                <table className="table table-row-bordered text-nowrap table-row-gray-100 align-middle gs-0 gy-3" style={{ minWidth: "1000px" }}>
                                                                    <thead>
                                                                        <tr className="fw-bold text-muted">
                                                                            <th className="min-w-140px">Date</th>
                                                                            <th className="min-w-160px">Account Head</th>
                                                                            <th className="min-w-120px">Ref User</th>
                                                                            <th className="min-w-120px">Operation</th>
                                                                            {(reportType == "All" || reportType == "Credit") &&
                                                                                <th className="min-w-120px">Credit</th>}
                                                                            {(reportType == "All" || reportType == "Debit") &&
                                                                                <th className="min-w-120px">Debit</th>}
                                                                            <th className="min-w-120px">User</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            accountReportList.map((obj, indx3) => {
                                                                                return (
                                                                                    <tr key={obj._id}>
                                                                                        <td><span className="text-dark fw-bold mb-1 fs-6 gap-2 d-flex align-items-center"><span>{moment(obj.log_date_time).format('ll')}</span><i onClick={(e) => { setOpen(true); setTransaction_log_details(obj) }} className="fa-solid fa-eye fs-2 p-0 text-hover-primary cursor-pointer"></i></span></td>
                                                                                        <td><span className="badge fs-8" style={{ backgroundColor: "cornflowerblue" }}>{AllAccountHeadList.find(option => option.value == obj.acc_hid).label}</span></td>
                                                                                        <td>{obj.ref_user_role != "" ? <span className="badge badge-secondary">{obj.ref_user_role} - {obj.ref_user_name}</span> : <span className="badge badge-secondary">--</span>}</td>
                                                                                        <td><a className="cursor-pointer d-flex gap-2"><span className="badge badge-secondary">{obj.operation}</span><span className="badge badge-primary">{obj.ref_number}</span></a></td>
                                                                                        <td><span className="text-success fw-bold d-block mb-1 fs-6">{baseCurrency.currency_symbol + formatNumber(obj.deposit_amnt, { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}</span></td>
                                                                                        <td><span className="text-danger fw-bold d-block mb-1 fs-6">{baseCurrency.currency_symbol + formatNumber(obj.withdrawl_amnt, { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}</span></td>
                                                                                        <td><span className="badge badge-secondary">{obj.user_id}</span></td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                            <div className="mt-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                    showQuickJumper={true}
                                                                />
                                                            </div>
                                                        </>
                                                        :
                                                        <div className="text-muted fs-2 my-auto text-center">No data to be shown {/* <br /> <br />
                                                            <button className='btn fs-3 btn-light-primary' onClick={() => { setFlowModalShow(true) }}>
                                                                Need Help <i className="bi bi-question-circle fs-1"></i>
                                                            </button> */}
                                                        </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            state == 2 ?
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                :
                                <PageError />
                    }
                </div>
            </div>

            <Drawer title={Dealer_name} width={window.innerWidth > 1200 ? 800 : 'auto'} style={{ body: { padding: "1.5rem" } }} onClose={onClose} open={open} closeIcon={<a onClick={onClose}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="38px" height="38px"><path fill="#f44336" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" /><path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z" /><path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z" /></svg>
            </a>}
                extra={
                    <Space>
                        {/* <Button onClick={onClose} type="primary">Close</Button> */}
                    </Space>
                }

            >
                <div className="card">
                    <div className="d-flex w-100 overflow-auto">
                        <ul className="nav nav-stretch nav-line-tabs fw-bold fs-6 p-0 p-lg-10 flex-nowrap flex-grow-1">
                            <li className="nav-item mx-lg-1">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Overview" && "active"}`} onClick={(e) => { setnavtype("Overview"); }}>Overview</a>
                            </li>
                            {/* <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Transactions" && "active"}`} onClick={(e) => { setnavtype("Transactions"); }}>Account Info</a>
                            </li> */}
                        </ul>
                    </div>
                </div>
                <div className="card">
                    {navtype === "Overview" ?
                        <>
                            {Transaction_log_details != null &&
                                <div
                                    className="card border-primary mb-3 mt-2"
                                    style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}
                                >
                                    <div className="card-header cursor-pointer py-3">
                                        <div className="card-title m-0">
                                            <h3 className="fw-bold m-0">
                                                {/* {Expense_details.expense_number} */}
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="card-body p-9">
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Transaction Date</label>
                                            <div className="col-lg-8">
                                                <span className="fw-bold fs-6 text-gray-800">{moment(Transaction_log_details.log_date_time).format("ll")}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Transaction By</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="fw-semibold text-gray-800 fs-6">{Transaction_log_details.user_id}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Branch</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="fw-semibold text-gray-800 fs-6">{branchList.find(option => option.branch_id == Transaction_log_details.branch).branch_name}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Account Head</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="badge badge-light-primary">{AllAccountHeadList.find(option => option.value == Transaction_log_details.acc_hid).label}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Account Category</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="fw-semibold text-gray-800 fs-6">{categoryList.find(option => option.value == Transaction_log_details.acc_cid).label}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Total Credit</label>
                                            <div className="col-lg-8 fv-row">
                                                {Transaction_log_details.deposit_amnt !== 0 ? <span className="text-success">+{Transaction_log_details.deposit_amnt}</span> : <span>---</span>}
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Total Debit</label>
                                            <div className="col-lg-8 fv-row">
                                                {Transaction_log_details.withdrawl_amnt !== 0 ? <span className="text-danger">+{Transaction_log_details.withdrawl_amnt}</span> : <span>---</span>}

                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Operation</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="badge badge-light-info fs-7 fw-bold">{Transaction_log_details.operation}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Status
                                            </label>
                                            <div className="col-lg-8 d-flex align-items-center">
                                                {Transaction_log_details.log_status === "PENDING_APPROVAL" ?
                                                    <span className="badge badge-light-warning">Pending</span>
                                                    :
                                                    Transaction_log_details.log_status === "DRAFT" ?
                                                        <span className="badge badge-secondary">Draft</span>
                                                        :
                                                        Transaction_log_details.log_status === "DRAFT" ?
                                                            <span className="badge badge-secondary">Draft</span>
                                                            :
                                                            Transaction_log_details.log_status === "cancelled" ?
                                                                <span className="badge badge-danger">Cancelled</span>
                                                                :
                                                                <span className="badge badge-success">{Transaction_log_details.log_status}</span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </>
                        :
                        navtype === "Transactions" ?
                            <>
                                <div className="card border-primary mb-3 mt-2" style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}>
                                    {Transaction_log_details != null &&
                                        <div className="card-body p-9">
                                            <div>
                                                {
                                                    Transaction_log_details.map((obj3, indx3) => {
                                                        return (
                                                            <>
                                                                <div className="payment-details-box" key={indx3} style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Account Name</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {obj3.account_name}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Calculation Method</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {obj3.calculation_mode == "Tax_Exclusive" ? <>Tax Exclusive</> : <>Tax Inclusive</>}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Amount</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {obj3.original_amount}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    {obj3.tax !== null &&
                                                                        <div className="row mb-2">
                                                                            <label className="col-lg-4 fw-semibold text-muted">Tax</label>
                                                                            <div className="col-lg-8">
                                                                                <span className="fw-bold fs-6 text-gray-800">
                                                                                    {obj3.tax_amount}
                                                                                </span>
                                                                            </div>
                                                                        </div>}
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Total amount</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {obj3.total_amount}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )
                                                    })
                                                }

                                            </div>
                                        </div>
                                    }
                                </div>
                            </>
                            :
                            navtype === "History" &&
                            <>
                                <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                    <div className="card-title m-0">
                                        History
                                    </div>
                                </div>
                                {/* {Transaction_log_details != undefined &&
                                <div className="card-body p-9">
                                    {Bank_history_details.length>0 && Bank_history_details.map((obj, index) => {
                                        return (
                                            <>
                                            <div className="m-0">
                                                <div className="d-flex align-items-sm-center mb-5">
                                                    <div className="d-flex align-items-center flex-row-fluid flex-wrap">                    
                                                        <div className="flex-grow-1 me-2">
                                                            {obj.operation === "insert" ? <span className="badge badge-lg badge-secondary fw-bold my-2">Created</span>:obj.operation === "cancelled" ? <span className="badge badge-lg badge-danger fw-bold my-2">Cancelled</span>:obj.operation === "voucher_creation" ?<><span className="badge badge-lg badge-success fw-bold my-2">Voucher Created</span><a href={`/dealer-master-voucher-summary/${obj.master_voucher_id}`} className="text-primary fw-bold me-1"> #{obj.master_voucher_name}</a></>:<span className="badge badge-lg badge-primary fw-bold my-2">Updated</span>}
                                                        </div>                     
                                                    </div>               
                                                </div>
                                                <div className="timeline">                                 
                                                    <div className="timeline-item align-items-center mb-7">
                                                        <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                        <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                                            <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                                            <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                                            </svg>
                                                        </span>
                                                        <div className="timeline-content m-0">
                                                            <span className="fs-6 text-gray-400 fw-semibold d-block">Date</span>
                                                            <span className="fs-6 fw-bold text-gray-800">{moment(obj.log_date_time).format("lll")} </span>   
                                                        </div>                                 
                                                    </div>
                                                    <div className="timeline-item align-items-center">
                                                        <div className="timeline-line w-40px"></div>
                                                        <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                            <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                            <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                                            </svg>
                                                        </span>
                                                        <div className="timeline-content m-0">
                                                            <span className="fs-6 text-gray-400 fw-semibold d-block">User</span>
                                                            <span className="fs-6 fw-bold text-gray-800">{obj.user_id}</span>
                                                        </div>                                
                                                    </div>                                        
                                                </div>
                                            </div>
                                            {Bank_history_details.length>1 &&
                                                <div className="separator separator-dashed my-6"></div>
                                            }
                                            </>
                                        )
                                    })}
                                </div>
                            } */}
                            </>
                    }
                </div>
            </Drawer>

        </>
    );
}
export default AccountReport;